import { QRCode } from "antd";

const QrCodePreview = ({ link }) => {
  return (
    <div className="flex flex-col items-center mt-4">
      <QRCode value={link} />
    </div>
  );
};
export default QrCodePreview;
